module.exports = __webpack_public_path__ + "static/media/alert.4eb09611.svg";